import { Helper } from '../../classes/helper'
import { OrbitControls } from '@react-three/drei'
import { useMontage } from '../../context/montage.context'
interface Props {
  orbitControls?: boolean
  axesHelper?: boolean
}

export const Utility = ({
  orbitControls = false,
  axesHelper = false,
}: Props): JSX.Element => {
  const isDevelopment = process.env.NODE_ENV !== 'production'

  const { ego } = useMontage()
  return (
    <>
      {orbitControls && !ego?.ego &&(
        <OrbitControls
          makeDefault
          attach={'orbitControls'}
          maxDistance={13.5}
          minDistance={5}
          rotateSpeed={0.7}
          enablePan={false}
          maxPolarAngle={Helper.convertAngleToRadiant(83)}
          minAzimuthAngle={Helper.convertAngleToRadiant(-75)}
          maxAzimuthAngle={Helper.convertAngleToRadiant(75)}
          target={[0,1,1]}
        />
      )}
       {ego?.ego && <OrbitControls
          makeDefault
          attach={'orbitControls'}
          maxDistance={102}
          minDistance={0}
          rotateSpeed={0.2}
          enablePan={false}
          minAzimuthAngle={Helper.convertAngleToRadiant(45)}
          maxAzimuthAngle={Helper.convertAngleToRadiant(-45)}
          target={[0, 1, 0.55]}
        /> }
      {axesHelper && isDevelopment && <axesHelper args={[2]} />}
    </>
  )
}
